import React from 'react';
import styled from 'styled-components'; // TODO: move to styled components
import { formatDateStrWithYearShort, formatTimeStr } from 'utils';
import styles from './appointment_book.module.scss';

const Step1TimeChange = ({
  appointment,
  listing,
  originalAppointment,
  updateState,
  currentStep,
  mobileWorkflowSteps,
  isAdmin,
  isMobile,
  isListingContact,
  keepOriginalAppointment,
}) => {
  const handleOptionChange = changeEvent => {
    const newValue = changeEvent.target.value;
    updateState(draft => {
      draft.keepOriginalAppointment = newValue === 'keep';
    });
  };

  const formHandler = e => {
    const { value } = e.target;
    updateState(draft => {
      draft.appointment.actionTaken = value;
    });
  };

  // If the suggested time change is requested based on another suggestion,
  // use the actual original value
  const originalSuggestedTimeChange =
    isListingContact &&
    originalAppointment.status === 'time_change' &&
    originalAppointment.listingContactTimeChange;

  const originalTime =
    originalSuggestedTimeChange && originalAppointment.originalTime
      ? originalAppointment.originalTime
      : originalAppointment.time;
  const originalTimeEnd =
    originalSuggestedTimeChange && originalAppointment.originalTimeEnd
      ? originalAppointment.originalTimeEnd
      : originalAppointment.timeEnd;

  return (
    <div
      className={`form-group col-md-4 ${
        currentStep === mobileWorkflowSteps.initialStep
          ? styles.stepActive
          : styles.stepInactive
      }`}
    >
      <hr className={`${styles.titleDivider} ${styles.titleDividerTop}`} />
      <h3 className={styles.titleBlock}>
        <span className={styles.stepNumber}>Step 1 - </span>
        <span className={styles.stepTitle}>Original Showing</span>
      </h3>
      <hr className={`${styles.titleDivider} ${styles.titleDividerBottom}`} />
      <div style={{ paddingLeft: '10px' }}>
        <label>{appointment.coop.name}</label>
        {isListingContact ? (
          <div className="appointment-small">
            {appointment.coop.org && (
              <>
                <div>{appointment.coop.org.name}</div>
                <div>{appointment.coop.org.address}</div>
              </>
            )}
          </div>
        ) : (
          <div className="appointment-small">
            <div>Mobile: {appointment.coop.phone}</div>
            <div>Email: {appointment.coop.email}</div>
            {isAdmin &&
              appointment &&
              appointment.coop &&
              appointment.coop.org && (
                <>
                  <label>{appointment.coop.org.name}</label>
                  <div>
                    {appointment.coop.org.address}
                    <br /> {appointment.coop.org.phone}
                  </div>
                </>
              )}
          </div>
        )}

        {isListingContact ? (
          <div className="appointment-small appointment-margin-top-extra1">
            <div className="row">
              <div className="col-md-2">
                <strong>Date:</strong>
              </div>
              <div className="col-md-10">
                {formatDateStrWithYearShort(originalTime, listing.timezone)}
              </div>
            </div>
            <div className="row">
              <div className="col-md-2">
                <strong>Time:</strong>
              </div>
              <div className="col-md-10">
                {formatTimeStr(originalTime, listing.timezone)} -{' '}
                {formatTimeStr(originalTimeEnd, listing.timezone)}
              </div>
            </div>
            <div className="row">
              <div className="col-md-2">
                <strong>Type:</strong>
              </div>
              <div className="col-md-10">{originalAppointment.type}</div>
            </div>

            {!isMobile && (
              <StyledSelectionMainContainer>
                <div>
                  If the showing agent declines the new date/time, what should
                  happen to their original request?
                </div>
                <StyledRadioContainer>
                  <StyledLabelContainer>
                    <StyledRadio
                      type="radio"
                      value="keep"
                      checked={keepOriginalAppointment}
                      onChange={handleOptionChange}
                    />
                    <StyledLabel isKeep>Keep Original</StyledLabel>
                  </StyledLabelContainer>
                  <StyledLabelContainer>
                    <StyledRadio
                      type="radio"
                      value="cancel"
                      checked={!keepOriginalAppointment}
                      onChange={handleOptionChange}
                    />
                    <StyledLabel>Cancel Original</StyledLabel>
                  </StyledLabelContainer>
                </StyledRadioContainer>
              </StyledSelectionMainContainer>
            )}
          </div>
        ) : (
          <div className="appointment-small appointment-margin-top">
            <div className="row">
              <div className="col-md-4">
                <strong>Day:</strong>
              </div>
              <div className="col-md-8">
                {formatDateStrWithYearShort(originalTime, listing.timezone)}
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <strong>Time:</strong>
              </div>
              <div className="col-md-8">
                {formatTimeStr(originalTime, listing.timezone)}
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <strong>Duration:</strong>
              </div>
              <div className="col-md-8">
                {appointment.duration.hours !== 0 && (
                  <span>{originalAppointment.duration.hours} Hour(s)</span>
                )}
                {appointment.duration.minutes !== 0 && (
                  <span>{originalAppointment.duration.minutes} Minutes</span>
                )}
              </div>
            </div>
            <div className="row" style={{ marginTop: '5px' }}>
              <div className="col-md-12">
                <div className="form-group">
                  <label>Notes</label>
                  <textarea
                    className="form-control"
                    onChange={formHandler}
                    rows="6"
                    value={appointment.actionTaken}
                    data-cy="input-note"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default Step1TimeChange;

const StyledSelectionMainContainer = styled.div`
  border: 0.5px solid #f4f4f4;
  border-radius: 3px;
  margin: 30px 0 0 -10px;
  padding: 10px 25px;
`;

const StyledRadioContainer = styled.div`
  margin: 10px 0 0 0;
  padding: 15px 15px 0 5px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const StyledLabelContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 15px 0;
  width: 49%;
  min-width: 130px;
`;

const StyledRadio = styled.input`
  margin: 0 !important;
`;

const StyledLabel = styled.span`
  margin: 0 0 0 10px;
  font-weight: bold;
  color: ${props => (props.isKeep ? 'green' : 'red')};
`;
